import * as React from 'react';
import { ControlLabel, FormControl, FormGroup, Row, Radio } from 'react-bootstrap';

interface IProps {
    recpInsPrimaryInsurance: string,
    recpInsPolicyHolderName: string,
    recpInsPolicyNumber: string,
    recpInsGroupId: string,
    recpInsRelationship: string,
    recpInsGender: string,
    recpInsDob: string,
    handleInsGenderSelect: (e: boolean) => void,
    handleInputChange: (e: React.FormEvent<FormControl & HTMLInputElement>) => void
}

class InsuranceInformation extends React.Component<IProps> {
    render = () => {
        return (
            <div className='col-sm-12'>
                <Row>
                    <div className='col-sm-12'>
                        <FormGroup controlId="recpPrimaryInsurance">
                            <ControlLabel>Primary Insurance</ControlLabel>
                            <FormControl
                                type="text"
                                name="recpInsPrimaryInsurance"
                                value={this.props.recpInsPrimaryInsurance}
                                placeholder="Primary Insurance"
                                onChange={this.props.handleInputChange}
                            />
                            <FormControl.Feedback />
                        </FormGroup>
                    </div>
                </Row>

                <Row>
                <div className='col-sm-12'>
                        <FormGroup controlId="recpInsPolicyNumber">
                            <ControlLabel>Medicare #</ControlLabel>
                            <FormControl
                                type="text"
                                name="recpInsPolicyNumber"
                                value={this.props.recpInsPolicyNumber}
                                placeholder="Policy Number"
                                onChange={this.props.handleInputChange}
                            />
                            <FormControl.Feedback />
                        </FormGroup>
                    </div>

                    <div className='col-sm-4'>
                        <FormGroup controlId="recpInsGroupId">
                            <ControlLabel>Group #</ControlLabel>
                            <FormControl
                                type="text"
                                name="recpInsGroupId"
                                value={this.props.recpInsGroupId}
                                placeholder="Enter Group Number"
                                onChange={this.props.handleInputChange}
                            />
                            <FormControl.Feedback />
                        </FormGroup>
                    </div>

                    <div className='col-sm-4'>
                        <FormGroup controlId="relationshipToInsured">
                            <ControlLabel>Relationship to Insured</ControlLabel>
                            <FormControl
                                type="text"
                                name="recpInsRelationship"
                                value={this.props.recpInsRelationship}
                                placeholder="Enter Relationship Type"
                                onChange={this.props.handleInputChange}
                            />
                            <FormControl.Feedback />
                        </FormGroup>
                    </div>
                </Row>

                <Row>
                    <div className='col-sm-4'>
                        <FormGroup controlId="stateText">
                            <ControlLabel>Policy Holder Name</ControlLabel>
                            <FormControl
                                type="text"
                                name="recpInsPolicyHolderName"
                                value={this.props.recpInsPolicyHolderName}
                                placeholder="Enter Policy Holder Name"
                                onChange={this.props.handleInputChange}
                            />
                            <FormControl.Feedback />
                        </FormGroup>
                    </div>

                    <div className='col-sm-4'>
                        <ControlLabel>Gender</ControlLabel>
                        <FormGroup 
                            value={this.props.recpInsGender}>
                            <Radio name="recpInsGender" checked={this.props.recpInsGender == 'M'} 
                        onClick={() => this.props.handleInsGenderSelect(true)} inline>
                                Male
                            </Radio>{' '}
                            <Radio name="recpInsGender" checked={this.props.recpInsGender == 'F'} 
                            onClick={() => this.props.handleInsGenderSelect(false)} inline>
                                Female
                            </Radio>{' '}
                        </FormGroup>
                    </div>

                    <div className='col-sm-4'>
                        <ControlLabel>Date of Birth</ControlLabel>
                        <FormControl
                            type='date'
                            name="recpInsDob"
                            value={this.props.recpInsDob}
                            onChange={this.props.handleInputChange}
                        />
                    </div>
                </Row>
            </div>
        )
    }
}

export default InsuranceInformation;